/**
 * Application Constants
 * 
 * This file contains application-wide constants including URLs, keys, and configuration values.
 */

// Re-export event constants from the single source of truth
// This maintains backwards compatibility for any code importing from this file
export {
  EVENT_TYPES,
  EVENT_TYPE_NAMES,
  RECURRENCE_PATTERNS,
  DAYS_OF_WEEK,
  getEventTypeLabel,
  getEventTypeBadge,
  getEventTypeColor,
  EVENT_TYPES_FOR_FILTER,
  ALL_EVENT_TYPES
} from './constants/eventConstants';

// Supabase Storage URLs for logo assets
export const LOGO_URLS = {
  // Full logo for headers, navbars, etc.
  FULL_LOGO: 'https://gsehsluenktbbnqqcxwi.supabase.co/storage/v1/object/public/logos/cheervue-logo.svg',
  
  // Badge/icon version of the logo for small displays
  BADGE_LOGO: 'https://gsehsluenktbbnqqcxwi.supabase.co/storage/v1/object/public/logos/cheervue-badge.svg',
  
  // Dark mode versions (currently same as light mode)
  FULL_LOGO_DARK: 'https://gsehsluenktbbnqqcxwi.supabase.co/storage/v1/object/public/logos/cheervue-logo.svg',
  BADGE_LOGO_DARK: 'https://gsehsluenktbbnqqcxwi.supabase.co/storage/v1/object/public/logos/cheervue-badge.svg',
};

// Application name
export const APP_NAME = 'CheerVue';

// Copyright information
export const COPYRIGHT = `© ${new Date().getFullYear()} CheerVue`;

// Default pagination values
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [5, 10, 20, 50, 100],
};

// Maximum file upload sizes (in bytes)
export const MAX_FILE_SIZES = {
  PROFILE_IMAGE: 2 * 1024 * 1024, // 2MB
  DOCUMENT: 5 * 1024 * 1024,     // 5MB
  VIDEO: 50 * 1024 * 1024,       // 50MB
}; 